import React from "react";
import { Message, EditProposal } from "../../../../contexts/SettingsContext";
import MessageRow from "./MessageRow";
import TypingIndicator from "./TypingIndicator";

const MessagesList: React.FC<{
  messages: Message[];
  isTyping: boolean;
  styles: any;
  messagesEndRef: React.RefObject<HTMLDivElement>;
  onRetry: (messageId: string) => void;
  retryingMessageId: string | null;
  onProposalsChange?: (messageId: string, proposals: EditProposal[]) => void;
}> = ({
  messages,
  isTyping,
  styles,
  messagesEndRef,
  onRetry,
  retryingMessageId,
  onProposalsChange,
}) => (
  <div className={styles.messagesContainer}>
    <div className={styles.messagesScroller}>
      {messages.map((msg, idx) => (
        <MessageRow
          key={msg.id || idx}
          msg={msg}
          styles={styles}
          onRetry={onRetry}
          isRetrying={msg.id === retryingMessageId}
          onProposalsChange={onProposalsChange}
        />
      ))}

      {isTyping && <TypingIndicator styles={styles} />}

      <div ref={messagesEndRef} />
    </div>
  </div>
);

export default MessagesList;
